<template>
  <b-container>
    <center v-if="load">
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>
    <b-row
      v-else
      class="m-0"
    >
      <b-col md="1" />
      <b-col
        lg="10"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >
        <b-col
          sm="10"
          md="9"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <validation-observer
            ref="InstitutionForm"
            #default="{ invalid }"
          >
            <b-form
              class="mt-2"
              @submit.prevent="submitInstitution"
            >
              <b-row>
                <b-col md="6">
                  <!-- experiment name -->
                  <b-form-group
                    label="Institution Name *"
                    label-for="Institution-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Institution Name"
                      vid="Institution-name"
                      rules="required"
                    >
                      <b-form-input
                        id="Institution-name"
                        v-model="InstitutionForm.name"
                        name="Institution-name"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Institution Name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- <b-col md="6">
                  <b-form-group
                    label=" deployment Name"
                    label-for="deployment Name"
                  >

                      <b-form-input
                        id="deployment Name"
                        v-model="InstitutionForm.deploymentName"
                        name="deployment Name"
                        placeholder="deployment Name"
                      />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="api Key" label-for="api Key">

                      <b-form-input
                        id="api Key"
                        v-model="InstitutionForm.apiKey"
                        name="api Key"
                        placeholder="api Key"
                      />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="api Version" label-for="api Version">

                      <b-form-input
                        id="api Version"
                        v-model="InstitutionForm.apiVersion"
                        name="api Version"
                        placeholder="api Version"
                      />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="base Url" label-for="base Url">

                      <b-form-input
                        id="base Url"
                        v-model="InstitutionForm.base_url"
                        name="base Url"
                        placeholder="base Url"
                      />

                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="azure Region" label-for="azure Region">

                      <b-form-input
                        id="azure Region"
                        v-model="InstitutionForm.azureRegion"
                        name="azure Region"
                        placeholder="azure Region"
                      />

                  </b-form-group>
                </b-col> -->
                <b-col
                  md="6"
                  class="mb-2"
                >
                  <!-- experiment total_seats -->
                  <b-form-group
                    label="Institution total seats *"
                    label-for="Institution-total_seats"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Institution Total Seats"
                      vid="Institution-total_seats"
                      rules="required|integer|min_value:1"
                    >
                      <b-form-input
                        id="Institution-total_seats"
                        v-model="InstitutionForm.total_seats"
                        name="Institution-total_seats"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Institution total seats"
                        type="number"
                        min="1"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="mb-2"
                >
                  <b-form-group
                    label="User Maximum Tokens per Year"
                    label-for="institution-user-max-token"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="User Maximum Tokens per Year"
                      vid="institution-user-max-token"
                      rules="integer|min_value:0|less_than_institution_max_token:@institution-max-token"
                    >
                      <b-form-input
                        id="institution-user-max-token"
                        v-model="InstitutionForm.user_max_token"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                        placeholder="User Maximum Tokens per Year"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="mb-2"
                >
                  <b-form-group
                    label="Institution Maximum Tokens per Year"
                    label-for="institution-max-token"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Institution Maximum Tokens per Year"
                      vid="institution-max-token"
                      rules="integer|greater_than_user_max_token:@institution-user-max-token"
                    >
                      <b-form-input
                        id="institution-max-token"
                        v-model="InstitutionForm.institution_max_token"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Institution Maximum Tokens per Year"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Expiry Date"
                    vid="expiry_date"
                    rules="required"
                  >
                    <b-form-group
                      label="Expiry date *"
                      label-for="expiry_date"
                    >
                      <b-input-group
                        class="input-group-merge form-send-message mr-1"
                      >
                        <flat-pickr
                          id="expiry_date"
                          v-model="InstitutionForm.expiry_date"
                          class="form-control custom-field"
                          placeholder="Expiry Date (DD-MM-YYYY)"
                          :config="{ dateFormat: 'Y-m-d' }"
                        />
                      </b-input-group>
                      <small class="text-danger float-left">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <!-- experiment name -->
                  <b-form-group
                    label="Enrolment Code *"
                    label-for="students_code"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Code"
                      vid="students_code"
                      rules="required"
                    >
                      <b-form-input
                        id="students_code"
                        v-model="InstitutionForm.students_code"
                        name="students_code"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Code"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Experiments Selection">
                    <b-form-radio-group
                      v-model="experimentSelectionType"
                      name="experiment-selection-type"
                    >
                      <b-form-radio value="all">
                        All Experiments
                      </b-form-radio>
                      <b-form-radio value="custom">
                        Custom Sellection
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <b-form-group
                    v-if="experimentSelectionType === 'custom'"
                    label-for="experiment-ids"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiments"
                      vid="experiment-ids"
                      rules="required"
                    >
                      <b-form-group
                        label="Experiments *"
                        label-for="experiment_ids"
                      >
                        <v-select
                          id="category_id"
                          v-model="InstitutionForm.experiment_ids"
                          multiple
                          :options="experimentsLookups"
                          class="w-100 mb-0 custom-field"
                          :reduce="(val) => val.id"
                          placeholder="Select Category"
                          :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                        >
                          <template v-slot:option="option">{{
                            $i18n.locale == "ar"
                              ? option.name_local
                              : option.name
                          }}</template>
                          <template #selected-option="{ name, name_local }">
                            <div style="display: flex; align-items: baseline">
                              <strong v-if="$i18n.locale == 'ar'">{{
                                name_local
                              }}</strong>
                              <strong v-else>{{ name }}</strong>
                            </div>
                          </template>
                          <template #no-options>{{
                            $t("noMatching")
                          }}</template>
                        </v-select>
                        <small class="text-danger float-left">{{
                          errors[0]
                        }}</small>
                      </b-form-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="AI Mode"
                    vid="ai_mode"
                  >
                    <b-form-group
                      label="AI Co-Teacher"
                      label-for="ai_mode"
                    >
                      <div class="ai-toggle">
                        <label class="switch">
                          <input
                            v-model="InstitutionForm.isAI"
                            type="checkbox"
                          >
                          <span class="slider" />
                        </label>
                        <span class="ai-text">{{
                          InstitutionForm.isAI ? "ON" : "OFF"
                        }}</span>
                      </div>
                      <small class="text-danger float-left">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row
                class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
              >
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="isLoading"
                  style="
                    background-color: #727272 !important;
                    border: unset !important;
                  "
                >
                  <b-spinner
                    v-if="isLoading"
                    type="grow"
                    small
                    class="ml-1"
                  />
                  <span v-else>{{ InstitutionID ? "Update" : "Create" }}</span>
                </b-button>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <b-col md="1" />
    </b-row>
  </b-container>
</template>

<script>
import {
  required, image, integer, minValue,
} from '@validations'
import { mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormSelect,
  BFormInput,
  BInputGroup,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'

extend('greater_than_user_max_token', {
  params: ['userMax'],
  validate(value, { userMax }) {
    const parsedValue = Number(value)
    const parsedUserMax = Number(userMax)
    const maxVal = !isNaN(parsedUserMax) ? parsedUserMax : 0
    // If user has no limit (0), institution can be anything
    if (maxVal === 0) return true
    // institution_max_token must be strictly greater than user_max_token
    // This includes the case where institution_max_token = 0 and user_max_token > 0
    return !isNaN(parsedValue) && parsedValue > maxVal
  },
  message: 'Institution Maximum Tokens per Year must be greater than User Maximum Tokens per Year',
})

extend('less_than_institution_max_token', {
  params: ['instMax'],
  validate(value, { instMax }) {
    if (!value || Number(value) === 0) {
      return true
    }
    const parsedInstMax = Number(instMax)
    const maxVal = !isNaN(parsedInstMax) ? parsedInstMax : 0
    if (maxVal === 0) {
      return true
    }
    return Number(value) < maxVal
  },
  message: 'User Maximum Tokens per Year must be less than Institution Maximum Tokens per Year',
})

export default {
  components: {
    vSelect,
    BSpinner,
    flatPickr,
    BContainer,
    BInputGroup,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormFile,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapGetters({
      experimentsLookups: 'experiments/experimentsLookups',
      item: 'institutions/item',
      load: 'institutions/load',
    }),
    InstitutionID() {
      return this.$route.params.id ? this.$route.params.id : null
    },
  },
  data() {
    return {
      experimentSelectionType: 'all',
      isLoading: false,
      InstitutionForm: {
        name: '',
        deploymentName: '',
        apiKey: '',
        apiVersion: '',
        base_url: '',
        azureRegion: '',
        total_seats: 0,
        user_max_token: 0,
        institution_max_token: 0,
        expiry_date: null,
        experiment_ids: [],
        isAI: false,
        all_experiments: false,
      },

      // validation rules
      required,
      image,
      integer,
      minValue,
    }
  },
  watch: {
    'InstitutionForm.user_max_token': function () {
      this.$nextTick(() => {
        if (this.$refs.InstitutionForm) {
          this.$refs.InstitutionForm.validate()
        }
      })
    },
    'InstitutionForm.institution_max_token': function () {
      this.$nextTick(() => {
        if (this.$refs.InstitutionForm) {
          this.$refs.InstitutionForm.validate()
        }
      })
    },
  },

  mounted() {
    this.init()
  },

  methods: {
    async init() {
      this.$store.dispatch('experiments/experimentsLookups')

      if (this.InstitutionID) {
        this.$store
          .dispatch('institutions/get', this.InstitutionID)
          .then(response => {
            this.InstitutionForm = this.item

            if (this.InstitutionForm.user_max_token === undefined) {
              this.$set(this.InstitutionForm, 'user_max_token', 0)
            }

            if (this.InstitutionForm.institution_max_token === undefined) {
              this.$set(this.InstitutionForm, 'institution_max_token', 0)
            }

            if (this.InstitutionForm.all_experiments) {
              this.experimentSelectionType = 'all'
            } else if (this.InstitutionForm.experiment_ids && this.InstitutionForm.experiment_ids.length > 0) {
              this.experimentSelectionType = 'custom'
            } else {
              // Default fallback if neither is clearly set, perhaps 'custom' with empty selection?
              this.experimentSelectionType = 'custom'
            }
          })
          .catch(e => {
            this.$swal({
              icon: 'error',
              title: `<h4>Error fetching experiment details: ${e.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
          })
      }
    },
    submitInstitution() {
      this.$refs.InstitutionForm.validate().then(success => {
        if (success) {
          // Manual validation: Institution Max must be greater than User Max
          const userMax = Number(this.InstitutionForm.user_max_token || 0)
          const instMax = Number(this.InstitutionForm.institution_max_token || 0)
          if (instMax > 0 && instMax <= userMax) {
            this.$swal({
              icon: 'error',
              title: '<h4>Validation Error</h4>',
              html: '<h4>Institution Maximum Tokens per Year must be greater than User Maximum Tokens per Year.</h4>',
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
            this.isLoading = false
            return
          }

          this.isLoading = true

          // If 'all' is selected, set all_experiments to true and clear specific IDs (optional, depending on backend)
          if (this.experimentSelectionType === 'all') {
            this.InstitutionForm.all_experiments = true
            this.InstitutionForm.experiment_ids = []
          } else {
            this.InstitutionForm.all_experiments = false
          }

          if (this.InstitutionID) {
            this.$store
              .dispatch('institutions/update', {
                query: this.InstitutionForm,
                id: this.InstitutionID,
              })
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Institution updated successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })

                this.isLoading = false
                this.$router.push({
                  name: 'institutions',
                })
              })
              .catch(error => {
                this.isLoading = false

                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error ?? error.response.data.message}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          } else {
            this.$store
              .dispatch('institutions/store', this.InstitutionForm)
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Institution created successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })

                this.$router.push({
                  name: 'institutions',
                })
                this.isLoading = false
              })
              .catch(error => {
                this.isLoading = false
                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error ?? error.response.data.message}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          }
        } else {
          this.$swal({
            icon: 'error',
            title: '<h4>Please fix the validation errors before submitting.</h4>',
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import '~flatpickr/dist/themes/dark.css';

[dir] .dark-layout input.form-control,
[dir] .dark-layout textarea.form-control,
[dir] .dark-layout .vs__dropdown-toggle {
  height: 45px;
  border-radius: 12px;
  padding: 0.6rem 1rem 0.6rem 2.5rem;
  background-color: #1f1f2b !important;
  border: 1px solid #2c2c3a;
  color: #fff !important;
  font-size: 15px;
  transition: border 0.2s ease-in-out;
}

[dir] .dark-layout input.form-control:focus,
[dir] .dark-layout textarea.form-control:focus,
[dir] .dark-layout .vs__dropdown-toggle:focus {
  border-color: #7367f0 !important;
  box-shadow: none;
}

.form-control::placeholder {
  color: #9ca3af !important;
  font-size: 14px;
}

.field-icon {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
}

/* vue-select */
.vs__dropdown-toggle {
  min-height: 45px !important;
  background-color: #121a2b !important;
  border-radius: 12px;
}

.vs__selected {
  color: #fff !important;
}

.vs__dropdown-menu {
  background: #1f1f2b;
  border-radius: 8px;
}

.vs__dropdown-option {
  color: #fff;
}

.vs__dropdown-option--highlight {
  background: #7367f0;
  color: #fff !important;
}

/* errors */
.text-danger {
  font-size: 13px;
  margin-top: 4px;
}

/* buttons */
.btn-primary {
  background: linear-gradient(90deg, #850dcc, #23c7ec);
  border: none !important;
  border-radius: 12px;
  padding: 0.7rem 2rem;
  font-weight: 600;
}

.btn-outline-primary {
  border: 1px solid #727272;
  border-radius: 12px;
  color: #fff;
  background: transparent;
  padding: 0.7rem 2rem;
}

/* === Global form styles fixed === */
input,
select,
textarea {
  background: #121a2b !important;
  color: #ffffff !important;
  border: 1px solid #2a324a !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  width: 100% !important;
  box-shadow: none !important;
  transition: border-color 0.3s ease, box-shadow 0.3s ease !important;
}

input::placeholder,
textarea::placeholder {
  color: #a5aec4 !important;
  opacity: 0.85 !important;
}

input:focus,
select:focus,
textarea:focus {
  border-color: #23c7ec !important;
  box-shadow: 0 0 0 2px rgba(35, 199, 236, 0.25) !important;
  outline: none !important;
}

/* === Labels === */
label {
  color: #bfc7e0 !important;
  font-size: 13px !important;
  margin-bottom: 6px !important;
  display: block;
}

/* === Error text === */
.error {
  color: #ff4d4f !important;
  font-size: 12px !important;
  margin-top: 4px !important;
}

/* === Upload Image / File Input === */
input[type="file"] {
  background: #121a2b !important;
  border: 1px dashed #2a324a !important;
  color: #a5aec4 !important;
  padding: 10px !important;
  cursor: pointer !important;
}

input[type="file"]::file-selector-button {
  background: linear-gradient(90deg, #850dcc 15%, #23c7ec 120%) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 6px 14px !important;
  margin-right: 10px !important;
  cursor: pointer !important;
}

input[type="file"]::file-selector-button:hover {
  opacity: 0.9 !important;
}

button {
  background: linear-gradient(90deg, #850dcc 15%, #23c7ec 120%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

button:hover {
  opacity: 0.9;
}

.ai-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 6px;
}

.switch {
  position: relative;
  width: 46px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #444;
  border-radius: 24px;
  transition: 0.3s;
}

.slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

input:checked + .slider {
  background: linear-gradient(90deg, #850dcc, #23c7ec);
}

input:checked + .slider::before {
  transform: translateX(22px);
}

.ai-text {
  color: #bfc7e0;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
